










































































































import Vue from 'vue';
import { mapState } from 'vuex';
import {
  Component, Watch, Inject,
} from 'vue-property-decorator';
import {
  Alert,
  NoticeClass,
  AuthStore,
} from '@kasasa/fbase-components/lib';
import { KCardHeader } from '@kasasa/fbase-components';
import DisclaimerFooter from '@/components/DisclaimerFooter.vue';
import QuestionCard from '@/components/QuestionCard.vue';
import { StringMap } from '@/api/i18n/';
import { Graph, Node, Edge } from '@/api/graph/';
import { Settings } from '@/api/settings/';
import { AnswerMap } from '@/api/AnswerMap';
import { FriendlyAnswer } from '@/api/FriendlyAnswer';
import AnswerSummary from '@/components/AnswerSummary.vue';
import { DocumentResource, PersistedAnswers } from '@/api/document/';


@Component({
  computed: mapState(['fiId', 'graphMap', 'fiSettings', 'auth', 'stringMap']),
  components: {
    DisclaimerFooter, QuestionCard, AnswerSummary, KCardHeader,
  },
})
export default class DocumentGeneratorMainView extends Vue {
  fiId!: string;

  currentNode: Node | null = null;

  graphMap!: Map<string, Graph>;

  fiSettings!: Settings;

  auth!: AuthStore;

  stringMap!: StringMap;

  nodeHistory: string[] = [];

  currentAnswers: AnswerMap = {};

  progressPercentage: number = 0;

  showSummary: boolean = false;

  graph: Graph | undefined | null = null;

  editMode: boolean = false;

  saving: boolean = false;

  title: string = '';

  headerItems: any = [
    {
      text: 'RegGen',
      disabled: false,
      link: false,
    },
    {
      text: '',
      disabled: true,
    },
  ];

  summaryHeaderItems: any = [
    {
      text: 'RegGen',
      disabled: false,
      link: false,
    },
    {
      text: '',
      disabled: false,
      link: true,
    },
    {
      text: 'Summary',
      disabled: true,
      link: false,
    },
  ]

  @Inject('DocumentResource')
  documentResource!: DocumentResource;

  @Watch('$route', { immediate: true, deep: true })
  onRouteChange() {
    this.loadGraphIfNecessary();

    if (this.graph) {
      this.currentNode = null;
      this.showSummary = false;

      if ((this.$route.name === 'adgSummary' || this.$route.name === 'mdgSummary') && this.graph.isTerminalPath(this.currentAnswers)) {
        this.nodeHistory = [];
        this.showSummary = true;
        this.summaryHeaderItems[1].href = `/${this.$route.params.clientId}/${this.graph.id}`;
      } else if (this.$route.params.nodeId) {
        const foundNode: Node | undefined = this.graph.getNode(this.$route.params.nodeId);

        if (!foundNode) {
          this.showErrorMessage(`Node with id ${this.$route.params.nodeId} not found!`);
        } else if (this.nodeHistory.length === 0 && foundNode.id !== this.graph.getEntryNode().id && this.currentAnswers[foundNode.id] === undefined) {
          // If we don't have node history, this isn't the first question, and there's no answer for it,
          // then we've tried to jump into the middle, so back out to the start.
          this.goToStart();
        } else {
          this.showNode(foundNode);
        }
      }
    }
  }

  loadGraphIfNecessary() {
    if (this.$route.path.includes('/mdg') && (this.graph == null || this.graph!.id !== 'mdg')) {
      this.graph = this.graphMap.get('mdg');
      this.currentAnswers = {};
      this.title = 'Marketing Disclaimers';
    } else if (this.$route.path.includes('/adg') && (this.graph == null || this.graph!.id !== 'adg')) {
      this.graph = this.graphMap.get('adg');
      this.currentAnswers = {};
      this.title = 'Account Disclosures';
    }
    if (!this.graph) {
      this.showErrorMessage('Question graph was not found!');
    }
    this.headerItems[1].text = this.title;
    this.summaryHeaderItems[1].text = this.title;
  }

  showNode(node: Node) {
    this.currentNode = node;
    this.editMode = this.graph!.isTerminalPath(this.currentAnswers);

    // If this node is in the history, trim it and everything after it.
    const historyPos:number = this.nodeHistory.indexOf(this.currentNode.id);
    if (historyPos !== -1) {
      this.nodeHistory.splice(historyPos);
    }

    this.progressPercentage = this.graph!.getProgressPercentage(this.currentNode.id);
  }

  onStart() {
    if (this.graph) {
      const entryNode = this.graph.getEntryNode();
      this.goToNode(entryNode.id);
    }
  }

  goToStart() {
    this.currentAnswers = {};
    if (this.graph!.id === 'mdg') {
      this.$router.push({ name: 'mdgMain', params: { clientId: this.$route.params.clientId } });
    } else {
      this.$router.push({ name: 'adgMain', params: { clientId: this.$route.params.clientId } });
    }
  }

  onNext(value: string | string[]) {
    if (this.currentNode) {
      this.currentAnswers[this.currentNode.id] = value;
      this.nodeHistory.push(this.currentNode.id);

      this.invalidateOnNext(value);

      if (this.graph?.isTerminalPath(this.currentAnswers)) {
        this.goToSummary();
      } else {
        let nextNodeId: string | null = this.currentNode.getNextNode(this.currentAnswers);
        let nodeIsValid: boolean = false;
        while (!nodeIsValid && nextNodeId) {
          const nextNode: Node | undefined = this.graph?.getNode(nextNodeId);
          if (nextNode && !nextNode.evaluateCondition(this.currentAnswers)) {
            nextNodeId = nextNode?.defaultNext;
          } else {
            nodeIsValid = true;
          }
        }
        if (nextNodeId !== null) {
          this.goToNode(nextNodeId);
        } else {
          // Should never happen unless someone starts answering questions then manually changes the URL to skip forward,
          // but if we got to the end but haven't answered the complete set of questions, just bounce back to the start.
          this.currentNode = null;
        }
      }
    }
  }

  invalidateOnNext(value: string | string[]) {
    let selectedEdges:Edge[];
    if (this.currentNode!.type === Node.CHECKBOX_TYPE) {
      selectedEdges = this.currentNode!.getEdgesForAnswers(value as string[]);
    } else {
      selectedEdges = [];
      const thisEdge: Edge | null = this.currentNode!.getEdgeForAnswer(value!);
      if (thisEdge) {
        selectedEdges.push(thisEdge);
      }
    }

    selectedEdges.forEach((edge:Edge) => {
      if (edge.invalidates) {
        this.invalidateQuestions(edge.invalidates);
      }
    });
  }

  invalidateQuestions(toInvalidate: string[]) {
    toInvalidate.forEach((nodeId: string) => {
      if (this.currentAnswers[nodeId]) {
        delete this.currentAnswers[nodeId];
      }
    });
  }

  goToSummary() {
    if (this.graph!.id === 'mdg') {
      this.$router.push({ name: 'mdgSummary', params: { clientId: this.$route.params.clientId } });
    } else {
      this.$router.push({ name: 'adgSummary', params: { clientId: this.$route.params.clientId } });
    }
  }

  onBack() {
    if (this.currentNode && this.nodeHistory.length > 0) {
      this.goToNode(this.nodeHistory.pop()!);
    } else if (this.graph!.id === 'mdg') {
      this.$router.push({ name: 'mdgMain', params: { clientId: this.$route.params.clientId } });
    } else {
      this.$router.push({ name: 'adgMain', params: { clientId: this.$route.params.clientId } });
    }
  }

  goToNode(nodeId: string) {
    if (this.graph!.id === 'mdg') {
      this.$router.push({ name: 'mdgQuestion', params: { clientId: this.$route.params.clientId, nodeId } });
    } else {
      this.$router.push({ name: 'adgQuestion', params: { clientId: this.$route.params.clientId, nodeId } });
    }
  }

  onDownload() {
    this.saving = true;

    let answers:AnswerMap | null = null;
    try {
      answers = this.buildAnswersForGeneration();
    } catch (error) {
      this.showErrorMessage(error);
      this.saving = false;
    }

    if (answers) {
      const friendlyAnswers: FriendlyAnswer[] = this.graph!.buildFriendlyAnswers(this.currentAnswers, this.fiSettings.attributes, this.stringMap!);
      this.documentResource.createDocument(this.fiId, {
        answers, friendlyAnswers, userName: this.getLoggedInUserFullName(), email: this.auth!.sessionData!.email,
      }).then((result:PersistedAnswers) => {
        window.location.href = `/api/document/${result.id}`;
      }).catch((error) => {
        this.showErrorMessage(error);
      }).finally(() => {
        this.saving = false;
      });
    }
  }

  getLoggedInUserFullName(): string {
    let name: string = '';

    if (this.auth?.sessionData?.firstName && this.auth.sessionData.firstName.length > 0) {
      name = `${this.auth.sessionData.firstName} `;
    }

    if (this.auth?.sessionData?.lastName && this.auth.sessionData.lastName.length > 0) {
      name += this.auth.sessionData.lastName;
    }

    return name;
  }

  buildAnswersForGeneration() : AnswerMap {
    const setupGraph:Graph | undefined = this.graphMap.get('settings');

    if (!setupGraph) {
      throw new Error('Unable to find setup question graph!');
    }

    let answers: AnswerMap = {};
    // set defaults
    if (this.graph?.defaults) {
      Object.assign(answers, this.graph.defaults);
    }

    if (this.graph!.id === 'mdg') {
      answers.documentType = 'MDG';
    } else {
      answers.documentType = 'ADG';
    }

    if (!answers.iop) {
      answers.iop = 'NO';
    }

    answers = { ...answers, ...this.graph!.buildAnswersForGeneration(this.currentAnswers), ...setupGraph!.buildAnswersForGeneration(this.fiSettings.attributes) };

    // handle special productType situation when following Kasasa generic path
    if (this.graph!.id === 'mdg') {
      if (answers.productTypes && (answers.productTypes === 'NO_PRODUCT' || (Array.isArray(answers.productTypes) && (answers.productTypes as string[]).includes('NO_PRODUCT')))) {
        // if comparison claims are made when no-product has been specified - Kasasa Cash is implied
        if (answers.comparisonClaims) {
          answers.productTypes = ['KASASA_CASH'];
        } else {
          // if no-product has been specified or implied - clear the product list before submitting
          answers.productTypes = [];
        }
      } else if (!Array.isArray(answers.productTypes)) {
        answers.productTypes = [answers.productTypes as string];
      }
    }

    return answers;
  }


  showErrorMessage(error: any) {
    console.error(error);
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
